import { SCAN_SITE } from './scanSite';

// Invite links look like  https://<site>/my-rewards?companyId=12&ref=AB12CD34
// The code is remembered until the friend signs in for the first time (it is sent with the OTP check).
const KEY = 'authx_ref';

export function captureReferral() {
  try {
    const r = new URLSearchParams(window.location.search).get('ref');
    if (r && /^[A-Z0-9]{4,12}$/i.test(r)) localStorage.setItem(KEY, r.toUpperCase());
  } catch {
    /* storage blocked */
  }
}

export const getReferral = () => {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
};

export const clearReferral = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

export const inviteLink = (code, companyId) => `${SCAN_SITE}/my-rewards?companyId=${companyId}&ref=${encodeURIComponent(code)}`;
